import { Currency } from '@typings/graphql-models';

export type { default as SlateNode } from './SlateNode';
export type Id = string;

export type Asset = {
  id: Id;
  url: string;
  fileName: string;
  mimeType: string;
  youTubeLink: string;
  vimeoUrl: string;
};

export type Image = Asset;

export type Video = Asset;

export type RichText = {
  html: string;
};

export enum Roles {
  Admin = 'admin',
  Creator = 'creator',
  Customer = 'customer'
}

export { Currency };
export const DEFAULT_CURRENCY = Currency.Usd;